import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('[Supabase] Initializing client');
console.log('[Supabase] URL configured:', SUPABASE_URL ? 'Yes' : 'No');
console.log('[Supabase] Key configured:', SUPABASE_ANON_KEY ? 'Yes' : 'No');

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('[Supabase] Missing configuration!');
  alert('Missing environment configuration. Please contact support.');
}

export const supabase = createClient(
  SUPABASE_URL || 'https://placeholder.supabase.co',
  SUPABASE_ANON_KEY || 'placeholder',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  }
);

console.log('[Supabase] Client created successfully');